import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
// import { useDeleteStore, useListStore } from "../stores";
import { toast } from 'react-toastify';
import { useMediaQuery } from 'react-responsive';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
// import { lte } from "lodash";
import { useSelector } from 'react-redux';
import moment from 'moment';
import axios from 'axios';
import { getAllTemplates } from '../actions';

export function CardList({ search, sort }) {
  console.log('ini search', search);
  console.log('ini sort', sort);
  const [load, setLoad] = useState(false);
  const [inputSearch, setInputSearch] = useState('');

  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    // console.log('get data post:', currentId);
    loadAllTemplates();
  }, [load]);

  const loadAllTemplates = () => {
    getAllTemplates().then((data) => {
      if (data.error) {
        console.log('Error get templates');
      } else {
        setTemplates(data);
      }
    });
  };

  // const themes = useSelector((state) => state.redTheme);

  const handleDelete = async (template) => {
    confirmAlert({
      title: 'Confirm to delete',
      message: `Are you sure want to delete "${template.templateName}"`,
      buttons: [
        {
          label: 'Delete',
          onClick: async () => {
            axios
              .delete(
                `http://localhost:9000/api/v1/delete-template/${template._id}`
              )
              .then((response, error) => {
                if (error) {
                  toast.warning(response.data.error);
                }
                setLoad(true);
                toast.warning(response.data.message);
              });
          },
        },
        {
          label: 'Cancel',
          onClick: () => {},
        },
      ],
    });
  };

  const baseImg =
    'https://cdn.pixabay.com/photo/2017/06/09/07/42/flower-2386049_960_720.jpg';

  const handleImgError = (e) => {
    e.target.src = baseImg;
  };

  const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1024 });
    return isDesktop ? children : Default;
  };
  const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
    return isTablet ? children : null;
  };
  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    return isMobile ? children : null;
  };
  const Default = ({ children }) => {
    const isNotTabletAndMobile = useMediaQuery({
      minWidth: 768,
      maxWidth: 990,
    });
    return isNotTabletAndMobile ? children : null;
  };

  let contentUi = <div className='loader-block' />;
  if (templates) {
    contentUi = (
      <>
        <section>
          <div className='ml-auto'>
            <div className='w-full mb-4'>
              <Desktop>
                <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg '>
                  <div className='px-6 py-4'>
                    <div className='grid lg:grid-cols-6'>
                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Gambar</p>
                      </div>

                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'> Name</p>
                      </div>

                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Type </p>
                      </div>

                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Total Questions</p>
                      </div>

                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Created At</p>
                      </div>

                      <div className='px-4 rounded'>
                        <p className='text-lg text-white'>Action</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Desktop>
            </div>

            {templates
              .filter((template) => {
                if (!search) return true;
                if (
                  template.templateName.toLowerCase().includes(search) ||
                  template.templateName.toLowerCase().includes(search) ||
                  template.templateName.toUpperCase().includes(search) ||
                  template.templateName.toUpperCase().includes(search)
                ) {
                  return true;
                }
              })
              .filter((template) => {
                if (!sort) return true;
                if (
                  template.type.toLowerCase().includes(sort) ||
                  template.type.toLowerCase().includes(sort) ||
                  template.type.toUpperCase().includes(sort) ||
                  template.type.toUpperCase().includes(sort)
                ) {
                  return true;
                }
              })
              .map((template, i) => (
                <>
                  <Desktop>
                    <div className='bg-white rounded overflow-hidden shadow-md rounded-lg mb-4 px-4 py-4'>
                      <div className='grid  lg:grid-cols-6'>
                        <div className='px-4  bg-white flex items-center rounded'>
                          <div className='avatar sm:w-28 sm:h-28 md:w-28 md:h-28 xl:w-28 xl:h-28 2xl:w-28 2xl:h-28'>
                            <img
                              src={template.selectedFile}
                              onError={handleImgError}
                              alt='template-avatar'
                            />
                          </div>
                        </div>
                        <div className='px-4  bg-white flex items-center rounded'>
                          <Link
                            to={`/template-management/detail/${template._id}`}
                          >
                            <p className='font-bold text-left '>
                              {template.templateName}
                            </p>
                          </Link>
                        </div>
                        <div className='px-4  bg-white flex items-center rounded'>
                          <p className='font-bold'>{template.type}</p>
                        </div>
                        <div className='px-4 bg-white flex items-center rounded'>
                          <p className='text-xs'>{template.questions.length}</p>
                        </div>

                        <div className='px-4  bg-white flex items-center rounded'>
                          {/* <p className='font-bold'>{template.createdAt}</p> */}
                          <div>
                            <p className='font-bold'>
                              {moment(
                                `${template.createdAt}`,
                                'YYYYMMDDHHmm'
                              ).format('HH:mm A')}
                            </p>
                            {/* <br /> */}
                            <p className='text-xs'>
                              {moment(
                                `${template.createdAt}`,
                                'YYYYMMDDHHmm'
                              ).format('DD/MM/YYYY')}
                            </p>
                          </div>
                        </div>
                        <div className='px-4 items-center rounded my-auto'>
                          <div className='flex items-center'>
                            <div className='flex items-center'>
                              <Link
                                to={`/template-management/edit/${template._id}`}
                                className='btn btn-icon btn_outlined btn_secondary'
                              >
                                <span className='la la-pen-fancy'></span>
                              </Link>
                              <button
                                type='button'
                                className='btn btn-icon btn_outlined btn_danger ml-2'
                                onClick={(e) => handleDelete(template)}
                              >
                                <span className='la la-trash-alt'></span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Desktop>

                  <Tablet>
                    <div className='bg-white overflow-hidden shadow-md rounded-lg mb-4 px-2 py-2'>
                      <div className='grid py-6 lg:grid-cols-5'>
                        <div className='px-4 bg-white flex items-center justify-center rounded '>
                          <Link
                            to={`/template-management/detail/${template.id}`}
                          >
                            <div className='items-center gap-3 max-w-xs'>
                              <div>
                                <div className='rounded-lg mb-3'>
                                  <img
                                    src={template.selectedFile}
                                    onError={handleImgError}
                                    alt='theme-avatar'
                                  />
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className='px-4 bg-white flex items-center justify-center rounded mb-3'>
                          <Link
                            to={`/template-management/detail/${template.id}`}
                          >
                            <div className='items-center gap-3 max-w-xs'>
                              <div>
                                <div>
                                  <p className='font-bold text-md'>
                                    {template.templateName}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className='px-4 bg-white flex items-center justify-center rounded mb-3'>
                          <div className='items-center gap-3 max-w-xs'>
                            <div>
                              <div>
                                <p className='font-bold text-xs'>
                                  {template.type}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='px-4 bg-white flex items-center justify-center rounded mb-3'>
                          <div className='items-center gap-3 max-w-xs'>
                            <p className='text-xs text-right'>
                              Total Questions <b>{template.questions.length}</b>
                            </p>
                          </div>
                        </div>
                        <div className='px-4 bg-white flex items-center justify-center rounded mb-3'>
                          <div className='items-center gap-3 max-w-xs'>
                            <p className='text-xs text-right'>
                              Created At{' '}
                              <b>
                                {moment(
                                  `${template.createdAt}`,
                                  'YYYYMMDDHHmm'
                                ).format('DD/MM/YYYY')}{' '}
                              </b>
                            </p>
                          </div>
                        </div>
                      </div>
                      <hr />

                      <Table
                        className='table border-none justify-center align-center mx-auto'
                        style={{ border: 'none !important' }}
                      >
                        <Tbody style={{ border: 'none !important' }}>
                          <Tr key={i} style={{ border: 'none !important' }}>
                            <Td className='items-center flex justify-center w-full'>
                              <div>
                                <Link
                                  to={`/template-management/edit/${template._id}`}
                                  className='btn btn-icon btn_outlined btn_secondary'
                                >
                                  <span className='la la-pen-fancy'></span>
                                </Link>
                              </div>
                              <div>
                                <button
                                  type='button'
                                  className='btn btn-icon btn_outlined btn_danger ml-2'
                                  onClick={(e) => handleDelete(template)}
                                >
                                  <span className='la la-trash-alt'></span>
                                </button>
                              </div>
                            </Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </div>
                  </Tablet>

                  <Mobile>
                    <div className='bg-white overflow-hidden shadow-md rounded-lg mb-4 px-2 py-2'>
                      <div className='grid py-6 lg:grid-cols-5'>
                        <div className='px-4 bg-white flex items-center justify-center rounded '>
                          <Link
                            to={`/template-management/detail/${template.id}`}
                          >
                            <div className='items-center gap-3 max-w-xs'>
                              <div>
                                <div className='rounded-lg mb-3'>
                                  <img
                                    src={template.selectedFile}
                                    onError={handleImgError}
                                    alt='theme-avatar'
                                  />
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className='px-4 bg-white flex items-center justify-center rounded mb-3'>
                          <Link
                            to={`/template-management/detail/${template.id}`}
                          >
                            <div className='items-center gap-3 max-w-xs'>
                              <div>
                                <div>
                                  <p className='font-bold text-md'>
                                    {template.templateName}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                        <div className='px-4 bg-white flex items-center justify-center rounded mb-3'>
                          <div className='items-center gap-3 max-w-xs'>
                            <div>
                              <div>
                                <p className='font-bold text-xs'>
                                  {template.type}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='px-4 bg-white flex items-center justify-center rounded mb-3'>
                          <div className='items-center gap-3 max-w-xs'>
                            <p className='text-xs text-right'>
                              Total Questions <b>{template.questions.length}</b>
                            </p>
                          </div>
                        </div>
                        <div className='px-4 bg-white flex items-center justify-center rounded mb-3'>
                          <div className='items-center gap-3 max-w-xs'>
                            <p className='text-xs text-right'>
                              Created At{' '}
                              <b>
                                {moment(
                                  `${template.createdAt}`,
                                  'YYYYMMDDHHmm'
                                ).format('DD/MM/YYYY')}{' '}
                              </b>
                            </p>
                          </div>
                        </div>
                      </div>
                      <hr />

                      <Table
                        className='table border-none justify-center align-center mx-auto'
                        style={{ border: 'none !important' }}
                      >
                        <Tbody style={{ border: 'none !important' }}>
                          <Tr key={i} style={{ border: 'none !important' }}>
                            <Td className='items-center flex justify-center w-full'>
                              <div>
                                <Link
                                  to={`/template-management/edit/${template._id}`}
                                  className='btn btn-icon btn_outlined btn_secondary'
                                >
                                  <span className='la la-pen-fancy'></span>
                                </Link>
                              </div>
                              <div>
                                <button
                                  type='button'
                                  className='btn btn-icon btn_outlined btn_danger ml-2'
                                  onClick={(e) => handleDelete(template)}
                                >
                                  <span className='la la-trash-alt'></span>
                                </button>
                              </div>
                            </Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </div>
                  </Mobile>
                </>
              ))}
          </div>
        </section>
      </>
    );
  }

  return contentUi;
}
